
import Vue from "vue";

import { DialogI } from "@/types/dialog";
import { reloadOnStaleChunks } from "@/utils/staleBuild";

export default Vue.extend({
  name: "DialogsContainer",

  // After a deploy a page loaded earlier asks for dialog files that no longer exist.
  components: reloadOnStaleChunks({
    CustomPopup: () => import("@/components/dialog/CustomPopup.vue"),
    CreateCourseDialog: () => import("@/components/dialog/CreateCourseDialog.vue"),
    AttachExistingLessonDialog: () => import("@/components/dialog/AttachExistingLessonDialog.vue"),
    AttachExistingExerciseDialog: () => import("@/components/dialog/AttachExistingExerciseDialog.vue"),
    CreateLessonDialog: () => import("@/components/dialog/CreateLessonDialog.vue"),
    DeleteConfirmationDialog: () => import("@/components/dialog/DeleteConfirmationDialog.vue"),
    DisplaySingleHintDialog: () => import("@/components/dialog/DisplaySingleHintDialog.vue"),
    DisplayHintsListDialog: () => import("@/components/dialog/DisplayHintsListDialog.vue"),
    LessonPreviewFinishedDialog: () => import("@/components/dialog/LessonPreviewFinishedDialog.vue"),
    SummaryDialog: () => import("@/components/dialog/summary_dialog/SummaryDialog.vue"),
    DeckWordsDialog: () => import("@/components/dialog/DeckWordsDialog.vue"),
    RepetitionSessionFinishedDialog: () => import("@/components/dialog/RepetitionSessionFinishedDialog.vue"),
    CourseFinishedDialog: () => import("@/components/dialog/CourseFinishedDialog.vue"),
    OnboardingLessonLeaveDialog: () => import("@/components/dialog/OnboardingLessonLeaveDialog.vue"),
    PlanTrophyDialog: () => import("@/components/dialog/PlanTrophyDialog.vue"),
    LessonGlossaryDialog: () => import("@/components/dialog/LessonGlossaryDialog.vue"),
    WelcomeDialog: () => import("@/components/dialog/WelcomeDialog.vue"),
    UserProfileActionsDialog: () => import("./UserProfileActionsDialog.vue"),
    UserProfileInvoiceDialog: () => import("./UserProfileInvoiceDialog.vue"),
    UserProfileDeleteProgressDialog: () => import("./UserProfileDeleteProgressDialog.vue"),
    UserProfileDeleteProgressConfirmDialog: () => import("./UserProfileDeleteProgressConfirmDialog.vue"),
    ReportBugDialog: () => import("@/components/dialog/ReportBugDialog.vue"),
    AddNote: () => import("@/components/dialog/AddNote.vue"),
    ListeningAndWritingActivitiesDialog: () => import("@/components/dialog/ListeningAndWritingActivitiesDialog.vue"),
    MediaAddFileDialog: () => import("@/components/dialog/MediaAddFileDialog.vue"),
    MediaRenameFileDialog: () => import("@/components/dialog/MediaRenameFileDialog.vue"),
    GiftCardAddDialog: () => import("@/components/dialog/GiftCardAddDialog.vue"),
    InviteUsersToCompany: () => import("@/components/dialog/InviteUsersToCompany.vue"),
    AddFirstAndLastNameToCompanyUser: () => import("@/components/dialog/AddFirstAndLastNameToCompanyUser.vue"),
    AssignAccessToCompanyUserDialog: () => import("@/components/dialog/AssignAccessToCompanyUserDialog.vue"),
    NotesDialog: () => import("@/components/dialog/NotesDialog.vue"),
    ChangeNicknameDialog: () => import("@/components/dialog/ChangeNicknameDialog.vue"),
    AiAssistantDialog: () => import("@/components/dialog/AiAssistantDialog.vue"),
    RepetitionAudioSelectCourseDialog: () => import("@/components/dialog/RepetitionAudioSelectCourseDialog.vue"),
    RepetitionAudioSelectLessonDialog: () => import("@/components/dialog/RepetitionAudioSelectLessonDialog.vue"),
    LessonWordsInfoDialog: () => import("@/components/dialog/LessonWordsInfoDialog.vue"),
    RepetitionWordsInfoDialog: () => import("@/components/dialog/RepetitionWordsInfoDialog.vue"),
    WordsModeInfoDialog: () => import("@/components/dialog/WordsModeInfoDialog.vue"),
    IntroLessonShowcaseDialog: () => import("@/components/dialog/IntroLessonShowcaseDialog.vue"),
    StreakSavedDialog: () => import("@/components/dialog/StreakSavedDialog.vue"),
    ThemeFollowDeviceDialog: () => import("@/components/dialog/ThemeFollowDeviceDialog.vue"),
    ProductionPromptDialog: () => import("@/components/dialog/ProductionPromptDialog.vue"),
  }),

  computed: {
    dialogs(): DialogI[] {
      return this.$store.getters["dialog/getList"];
    },
  },
});
